module API.Account where

import Common

import API.SelStudent (SelStudent)
import Data.Argonaut (class DecodeJson)
import Data.Argonaut as J
import GraphQL.Query (Query, buildQuery, nameQuery)
import GraphQL.Shape (Union, fromUnionTag)
import Type.Prelude (Proxy(..))

data AccountType = StudentAccount | TeacherAccount | BoardAccount
derive instance eqAccType :: Eq AccountType
instance decodeAccType :: DecodeJson AccountType where
    decodeJson json = case J.toString json of
        Just "STUDENT" -> Right StudentAccount
        Just "TEACHER" -> Right TeacherAccount
        Just "BOARD_ADMIN" -> Right BoardAccount
        _ -> Left $ TypeMismatch "AccountType"

type AccountInfo =
    { type :: AccountType
    , student :: Maybe SelStudent
    }

queryAccountInfo :: Query AccountInfo
queryAccountInfo = nameQuery "AccountInfo" $ process <$> buildQuery "me" {}
  where
    process :: { account_type :: AccountType, account :: Maybe (Union ( "Student" :: SelStudent )) }
        -> AccountInfo
    process { account_type, account } =
        { type: account_type, student: fromUnionTag studentTag =<< account }
    studentTag :: Proxy "Student"
    studentTag = Proxy
